import React, { Fragment } from 'react';
import { ExpandableButton } from '@/_elements/Button';
import { FaPlus } from 'react-icons/fa';
import { Modal } from 'react-bootstrap';
import { FloatingContainer, ModalFormContainer } from './smartpdf/styles';
import styled from '@emotion/styled';
import FormPicker from './FormPicker';

const StyledModalDialog = styled(Modal.Dialog)`
    &&& {
        position: fixed;
        right: 20px !important;
        left: auto !important;
        margin: 0 !important;
        width: 350px !important;
        max-width: none !important;
        top: 10px;
    }
`;

const FormPickerModal = React.memo(
    ({ teamId, formId, openFormBuilder, show, setShowFormPickerModal = () => {}, draggable }) => {
        const handleShow = () => setShowFormPickerModal(true);
        const handleClose = () => setShowFormPickerModal(false);

        return (
            <Fragment>
                <FloatingContainer bottom="30px" right="60px" zIndex={2} onClick={() => handleShow()}>
                    <ExpandableButton
                        size={'70px'}
                        icon={<FaPlus size={40} />}
                        text="Add New Form Element"
                        backgroundColor="#fff"
                        borderColor="#ccc"
                        textColor="#50aeb0"
                        expandDirection="left"
                    />
                </FloatingContainer>
                <Modal show={show} onHide={handleClose} dialogAs={StyledModalDialog} scrollable={true}>
                    <ModalFormContainer>
                        <Modal.Header closeButton>
                            <Modal.Title className="w-100 text-center">Pick Form Element</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormPicker
                                openFormBuilder={openFormBuilder}
                                teamId={teamId}
                                formId={formId}
                                onCloseModal={handleClose}
                                draggable={draggable}
                            />
                        </Modal.Body>
                    </ModalFormContainer>
                </Modal>
            </Fragment>
        );
    }
);

export default FormPickerModal;
